import styled from "styled-components/macro";
import homeBgFull from "../../../../images/homeBgFull.png";
import newBg from "../../../../images/newBg.png";
import oppoBg from "../../../../images/opposite.png";
const defaultLanguage = window.localStorage.getItem("rcml-lang") || "en";

export const InfoContainer = styled.div`
  color: #fff;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${defaultLanguage === "ar" ? `url(${oppoBg}) center top / 100% 100% no-repeat` : `url(${newBg}) center top / 100% 100% no-repeat`};
  @media screen and (max-width: 768px) {
    padding: 20px 0;
    position: relative;
    height: 800px;
  }

  @media screen and (max-width: 480px) {
    height: 670px;
  }

  @media screen and (max-width: 375px) {
    height: 600px;
  }
`;
export const InfoWrapper = styled.div`
  z-index: 1;
  /* height: 600px; */
  width: 100%;
  max-width: 1200px;
  margin-right: auto;
  margin-left: auto;
  display: flex;
  justify-content: space-between;
  padding-top: 5rem;
  direction: ${defaultLanguage === "ar" ? "rtl" : "ltr"};
  @media (max-width: 769px) {
    padding-top: 0;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  /* background-color: aqua; */
`;
export const TextWrapper = styled.div`
  max-width: 50%;
  width: 50%;
  /* background-color: lightgray; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: end;
  @media (max-width: 1375px) {
    padding-right: 2rem;
  }
  @media (max-width: 769px) {
    max-width: 100%;
    width: 100%;
    align-items: center;
    padding-right: 0;
    padding: 0 1rem;
  }
  `;
export const TopLine = styled.div`
  display: flex;
  justify-content: end;
  color: #ff9900;
  font-size: 1.1rem;
  line-height: 16px;
  font-weight: 500;
  letter-spacing: 3.2px;
  text-transform: uppercase;
  margin-bottom: 1rem;
  font-family: "Montserrat";
  opacity: 1;
  @media (max-width: 769px) {
    justify-content: center;
    text-align: center;
   }
  @media (max-width: 333px) {
    font-size: 1rem;
   }
`;

export const Heading = styled.div`
  /* margin-bottom: 24px; */
  font-size: 2.8rem;
  font-family: "Montserrat";
  text-align: ${defaultLanguage === "ar" ? "left" : "right"};
  // line-height: 1.1;
  font-weight: 800;
  padding-left: ${defaultLanguage === "ar" ? "0" : "2rem"};
  padding-right: ${defaultLanguage === "ar" ? "2rem" : "0"};
  color: #000000;
  opacity: 1;

  @media screen and (max-width: 1192px) {
    font-size: 2.6rem;
  }
  @media screen and (max-width: 1088px) {
    padding-left: 1rem;
  }
  @media screen and (max-width: 1056px) {
    padding-left: 0;
  }
  @media screen and (max-width: 874px) {
    font-size: 2rem;
  }
  @media screen and (max-width: 769px) {
    text-align: center;
  }
  @media screen and (max-width: 517px) {
    text-align: center;
  }
  @media screen and (max-width: 480px) {
    font-size: 1.7rem;
  }
`;


export const HeadingSub = styled.div`
  display: flex;
  justify-content: end;
  /* margin-bottom: 24px; */
  font-size: 2.8rem;
  font-family: "Montserrat";
  // line-height: 1.1;
  font-weight: 800;
  color: #000000;
  opacity: 1;

  @media screen and (max-width: 480px) {
    font-size: 32px;
  }
`;
export const Subtitle = styled.div`
  max-width: 440px;
  margin-bottom: 35px;
  font-size: 18px;
  line-height: 24px;
  // color: ${({ darkText }) => (darkText ? "#010606" : "#fff")};
`;
export const BtnWrap = styled.div`
  display: flex;
  justify-content: flex-start;
`;
export const ImgWrap = styled.div`
  height: 100%;
  max-width: 50%;
  width: 50%;
  @media (max-width: 769px) {
    max-width: 100%;
    width: 100%;
  }
  @media (max-width: 523px) {
    /* padding-top: 3rem; */
  }
`;
export const Img = styled.img`
  width: 100%;
  margin: 0 0 10px 0;
  padding-right: 0;
`;

export const SiginDescription = styled.div`
  display: flex;
  justify-content: ${defaultLanguage === "ar" ? "start" : "end"};;
  font-weight: 400;
  font-size: 0.9rem;
  font-family: "Montserrat";
  letter-spacing: 0px;
  color: #31353b;
  text-align: ${defaultLanguage === "ar" ? "left" : "right"};
  opacity: 1;
  margin-top: 1rem;
  line-height: 1.7;
  padding-left: ${defaultLanguage === "ar" ? "0" : "0rem"};;
  padding-right: ${defaultLanguage === "ar" ? "8rem" : "0"};;

  @media screen and (max-width: 1249px) {
    padding-left: 5rem;
  }
  @media screen and (max-width: 1153px) {
    padding-left: 2rem;
  }
  @media screen and (max-width: 1037px) {
    padding-left: 0;
  }
  @media screen and (max-width: 769px) {
    text-align: center;
  }
  @media screen and (max-width: 480px) {
    font-size: 0.8rem;
  }

  @media screen and (max-width: 375px) {
    font-size: 0.7rem;
  }

  @media screen and (max-width: 320px) {
    font-size: 0.6rem;
  }
`;

export const SiginDescriptionSub = styled.div`
  display: flex;
  justify-content: end;
  font-weight: 400;
  font-size: 0.9rem;
  font-family: "Montserrat";
  letter-spacing: 0px;
  color: #31353b;
  text-align: left;
  opacity: 1;
  margin-top: 0.2rem;
  line-height: 1.7;

  @media screen and (max-width: 480px) {
    font-size: 0.8rem;
  }

  @media screen and (max-width: 375px) {
    font-size: 0.7rem;
  }

  @media screen and (max-width: 320px) {
    font-size: 0.6rem;
  }
`;

export const SearchBox = styled.div`
  display: flex;
  box-shadow: 0px 16px 20px #0000000f;
  border: 1px solid #dadada;
  border-radius: 4px;
  opacity: 1;
  margin-top: 2rem;
  background: #ffffff 0% 0% no-repeat padding-box;
  width: 90%;
  margin-bottom: 2.5rem;

  /* @media(max-width: 768px){
        display: none;
    } */
`;

export const InputSearch = styled.div`
  height: auto;
  width: 100%;
  display: flex;
  /* border-left: 0.5px solid #4993FF; */
  align-items: center;
`;

export const InputFeild = styled.input`
  height: auto;
  border: none;
  outline: none;
  width: 100%;
  text-align: left;
  font-weight: 300;
  font-size: 0.8rem;
  font-family: "Montserrat";
  letter-spacing: 0px;
  opacity: 0.8;
  padding: 0 9px;
  color: #31353b;

  @media screen and (max-width: 480px) {
    font-size: 0.6rem;
  }
`;

export const SearchIcon = styled.img`
  margin-left: 1rem;
  width: 3%;
`;

export const SearchIconWrap = styled.div``;

export const SearchButton = styled.button`
  box-shadow: rgb(0 0 0 / 19%) 0px 0px 10px;
  border-radius: 4px;
  opacity: 1;
  margin: 0.1em;
  white-space: nowrap;
  padding: 1.2em 2.5em;
  border: none;
  background: rgb(235, 125, 53);
  color: rgb(255, 255, 255);
  font-size: 1rem;
  outline: none;
  cursor: pointer;
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  transition: all 0.2s ease-in-out 0s;
  text-decoration: none;
  font-weight: 400;
  font-size: 1rem;
  font-family: "Montserrat";
  letter-spacing: 0px;

  @media screen and (max-width: 480px) {
    padding: 0.8em;
    font-size: 0.8rem;
  }
`;

export const PartnerText = styled.div`
  font-weight: 500;
  font-size: 0.9rem;
  font-family: "Montserrat";
  color: #31353b;
  text-align: left;
  opacity: 1;
  margin-top: 3rem;
`;

export const SponserWrap = styled.div`
  margin-top: 1.5rem;
  display: flex;
  height: auto;
  justify-content: space-between;
  align-items: center;
  width: 90%;
`;

export const SponserImg = styled.img`
  height: 10%;
  width: 11%;

  @media screen and (max-width: 1024px) {
    height: 40%;
  }

  @media screen and (max-width: 768px) {
    height: 50%;
    margin-right: 0.4rem;
  }

  @media screen and (max-width: 620px) {
    height: 45%;
  }

  @media screen and (max-width: 480px) {
    height: 38%;
    margin-right: 0.5rem;
  }

  @media screen and (max-width: 375px) {
    height: 30%;
  }
`;
